import { Record, type RecordOf } from 'immutable';

import {
  type BaseResource,
  createTypedQcsSyncResourceStoreFactory,
  type QcsSyncResourceStore,
} from '../core/resourceStoreTypes';

export const ACCOUNTS_BALANCES_REDUCER_KEY = 'accountsBalancesStore';

export type AccountsBalanceType = 'CURRENT' | 'ONLINE' | 'UNKNOWN';

// Preserve the legacy Record's undefined defaults, including for optimistic
// writes that have a clientId before receiving their server id and timestamps.
export type AccountsBalanceProps = BaseResource & {
  createdAt?: string | null;
  modifiedAt?: string | null;
  accountId?: string | null;
  balanceType?: AccountsBalanceType | null;
  balanceAmount?: number | null;
  balanceAt?: string | null;
  balanceOn?: string | null;
};

export type AccountsBalance = RecordOf<AccountsBalanceProps>;
export type AccountsBalancesStore = QcsSyncResourceStore<AccountsBalanceProps>;

export const mkAccountsBalance = Record<AccountsBalanceProps>({
  id: undefined,
  clientId: undefined,
  createdAt: undefined,
  modifiedAt: undefined,
  accountId: undefined,
  balanceType: undefined,
  balanceAmount: undefined,
  balanceAt: undefined,
  balanceOn: undefined,
  isDeleted: undefined,
});

export const mkAccountsBalancesStore = createTypedQcsSyncResourceStoreFactory<AccountsBalanceProps>();

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [ACCOUNTS_BALANCES_REDUCER_KEY]: AccountsBalancesStore;
  }
}
